type PropTypes = {
  className?: string
}

const PlusIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      className={className}
    >
      <path fill="currentColor" d="M4.5 3.5V0h-1v3.5H0v1h3.5V8h1V4.5H8v-1H4.5Z" />
    </svg>
  )
}

export default PlusIcon
